import { IFormTypeService } from "../../service/formconfiguration/FormTypeService";
import { IFormType } from "../../model/formconfiguration/FormType";

export default class CreateNewFormVersionInteractor {
  private formTypeService: IFormTypeService;

  constructor(formTypeService) {
    this.formTypeService = formTypeService;
  }

  async execute(formTypeCode: string, formType: IFormType) {
    await this.formTypeService.createNewFormVersion(formTypeCode, formType);
  }
}
